import React from "react"

const CircularProgress = ({ value = 0, size = 50, strokeWidth = 3 }) => {
    const formattedValue = value > 100 ? 100 : (value < 0 ? 0 : value)
    const radius = (size - strokeWidth) / 2
    const circumference = 2 * Math.PI * radius
    const progress = (formattedValue / 100) * circumference

    return (
        <svg width={size} height={size}>
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="var(--border-subtle-color)"
                strokeWidth={strokeWidth}
                fill="none"
            />
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="var(--brand-secondary)"
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={circumference - progress}
                strokeLinecap="round"
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
            <text x="50%" y="50%" textAnchor="middle" dy=".3em" fontSize="12" fill="var(--text-secondary)" style={{ userSelect: 'none' }}>
                {`${formattedValue}%`}
            </text>
        </svg>
    )
}

export default CircularProgress
